import React, { useState } from 'react';
import './styles.css';

import Header from './components/functional/Header';
import Listing from './components/functional/Listing';
import Creation from './components/functional/Creation';
import Notification from './components/functional/Notification';

function Wallet() {
  const [update, setUpdate] = useState(false);

  return (
    <div className="wa-wrapper">
      <Header />
      <main>
        <div className="wa-container main__content">
          <div className="main__left">
            <Creation onUpdateTable={() => setUpdate(stt => !stt)} />
            <Notification />
          </div>
          <Listing update={update}/>
        </div>
      </main>
    </div>
  );
}

export default Wallet;


// WEBPACK FOOTER //
// ./src/components/Pages/Wallet/index.js